import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { Box, styled } from '@mui/material';

export const SLIDER_SETTINGS = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 5000,
  arrows: true,
  prevArrow: <ChevronLeft aria-label="Previous step" />,
  nextArrow: <ChevronRight aria-label="Next step" />,
};

export const SliderBox = styled(Box)(({ theme }) => ({
  '& .slick-prev, & .slick-next': {
    color: `${theme.vars.palette.grey[800]} !important`,
    backgroundColor: `${theme.vars.palette.grey[200]} !important`,
    width: 30,
    height: 30,
    p: '5px',
    borderRadius: '50%',
    zIndex: 9,
    '&:before': {
      display: 'none',
    },
  },
  '& .slick-disabled': {
    color: `${theme.vars.palette.grey[400]} !important`,
    cursor: 'default',
  },
  '& .slick-prev': {
    left: -15,
  },
  '& .slick-next': {
    right: -15,
  },
}));
